// extracted by mini-css-extract-plugin
export default {"advertDetailHeader":"c-n_fO"};